import defaultAxiosClient from '../plugins/axios';

const initialState = {
    currentLoggedUser: null,
    selectedUser: null,
    profile: {},
};

const user = {
    namespaced: true,
    state: () => ({
        ...initialState
    }),
    getters: {
        currentLoggedInUser(state) {
            return state.currentLoggedUser;
        },
        selectedUser(state) {
            return state.selectedUser;
        },
        profile: state => state.profile,
    },
    mutations: {
        resetState(state) {
            Object.assign(state, initialState);
        },
        setSelectedUser: (state, selectedUser) => {
            state.selectedUser = selectedUser;
        },
        setCurrentUser(state, currentUser) {
            state.currentLoggedUser = currentUser;
        },
        setProfile(state, payload) {
            state.profile = payload;
        }
    },
    actions: {
        async fetchUser({commit}) {
            const response = await defaultAxiosClient.get('/user/current');
            commit('setCurrentUser', response.data);
        },
        clearUserData({commit}) {
            commit('resetState');
        },
        fetchProfile({commit}) {
            return defaultAxiosClient.get('/user/profile')
                .then(response => commit('setProfile', response.data))
                .catch(() => commit('resetState'));
        }
    }
};
export default user;
